import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useOutletContext } from 'react-router-dom';
import Layout from '../components/Layout';
import StaffDashboard from '../staff_pages/StaffDashboard';
import StaffTimetable from '../staff_pages/StaffTimetable';

// PageWrapper component to handle page titles
const PageWrapper = ({ children, title }) => {
  const { setPageTitle } = useOutletContext() || {};
  useEffect(() => {
    if (setPageTitle && title) {
      setPageTitle(title);
    }
  }, [title, setPageTitle]);
  return <>{children}</>;
};

// Placeholder for pages that are not yet built
const PlaceholderPage = ({ title }) => (
  <div style={{ padding: '40px', textAlign: 'center' }}>
    <h2>{title} - Coming Soon 🚧</h2>
    <p>This feature will be available soon.</p>
  </div>
);

export default function StaffRoutes() {
  return (
    <Routes>
      <Route element={<Layout />}>
        {/* Default redirect for /staff to /staff/dashboard */}
        <Route index element={<Navigate to="dashboard" replace />} />
        
        <Route path="dashboard" element={<PageWrapper title="Faculty Dashboard"><StaffDashboard /></PageWrapper>} />
        
        {/* Course Management Routes */}
        <Route path="my-courses" element={<PageWrapper title="My Courses"><PlaceholderPage title="My Courses" /></PageWrapper>} />
        <Route path="manage-grades" element={<PageWrapper title="Manage Grades"><PlaceholderPage title="Manage Grades" /></PageWrapper>} />
        <Route path="manage-attendance" element={<PageWrapper title="Manage Attendance"><PlaceholderPage title="Manage Attendance" /></PageWrapper>} />
        <Route path="timetable" element={<PageWrapper title="My Timetable"><StaffTimetable /></PageWrapper>} />

        {/* Student Info Routes */}
        <Route path="student-list" element={<PageWrapper title="Student List"><PlaceholderPage title="Student List" /></PageWrapper>} />
      </Route>
    </Routes>
  );
}